import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import DefeitoFabricacao from "model/meta/producao/DefeitoFabricacao";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import "react-hook-form";
import { useForm } from "react-hook-form";
import DefeitoFabricacaoService from "service/meta/producao/DefeitoFabricacaoService";

const defeitoFabricacaoService = new DefeitoFabricacaoService();

export default function DefeitoFabricacaoCadastro() {

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [defeitoFabricacao, setDefeitoFabricacao] = useState<DefeitoFabricacao>(new DefeitoFabricacao());
    const [titulo, setTitulo] = useState<string>('Defeito de fabricação');

    function validar() {

        if (!defeitoFabricacao.descricao) {
            setError("descricao", { type: "manual", message: "Descrição é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={defeitoFabricacao} service={defeitoFabricacaoService} setModel={(value: DefeitoFabricacao) => setDefeitoFabricacao(value)} validar={() => validar()} urlService="/defeitoFabricacao" pathCadastro="/defeitoFabricacao" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.descricao ? "p-invalid" : ""}
                        required value={defeitoFabricacao.descricao}
                        style={{ width: '30%' }}
                        {...register("descricao", {
                            onChange: (e) => {
                                setDefeitoFabricacao({ ...defeitoFabricacao, descricao: e.target.value })
                                clearErrors("descricao")
                            }
                        })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>

        </BaseCadastro>
    )
}
